/** 
* 这里就可以单独写bak组件的状态了
* mutations 中的方法是不分组件的 , 假如你在 dialog_stroe.js 文件中的定义了
* switch_dialog 方法 , 在其他文件中的一个 switch_dialog 方法 , 那么
* $store.commit('switch_dialog') 会执行所有的 switch_dialog 方法。
* mutations里的操作必须是同步的。
* 通过 store.state 来获取状态对象，以及通过 store.commit 方法触发状态变更：
* getter 方法是获取数据  不会对原数据造成影响的函数
* actions 异步操作  action只管中间处理，处理完我就给你，你怎么存我不管；
* mutations 存储数据  同步操作 只管存，你给我（dispatch）我就存
* 我们将之前我们使用的 $store.state.show 统统改为 $store.state.dialog.show 即可
* // 这是更新路由的方法
    this.$router.push({  
        path:'/y',    //这是路由名称      
    })
*/
// 引入axios组件
import axios from 'axios';
import qs from 'qs';//处理数据  qs.stringify(params)
export default {
    state:{
        show:false,
        baklist:[],//存储数据库备份列表的数组
        bakinfo:"",//存储数据库备份，还原，删除请求的信息
        sowingList:'',//存储轮播图列表
        personalInfo:'',//存储个人信息
    },
    mutations:{
        /*switch_dialog(state){//这里的state对应着上面这个state
            state.show = state.show ? false : true;
            //你还可以在这里执行其他的操作改变state
        }//*/
        saveDbListInfo(state,value){
            state.baklist = value;
            // console.log(value)
        },
        saveDbListInfoAgain(state, value) {
            let self = this;
            // 数据库备份页
            axios({
                method: "post",
                url: "/admin/dbbak/baklist",
                data: {}
            })
            .then(function (response) {
                // store.commit("saveDbListInfo", response.data.dblist);
                state.baklist = response.data.dblist;
            })
            .catch(function (response) {
                console.log(response);
            });
        },
        // 存储轮播图列表
        saveSowingList(state, value){
            console.log(value);
            state.sowingList = value;
        },
        // 存储个人信息
        getPersonalInfo(state, value){
            console.log(value);
            state.personalInfo = value.personalInfo;   
        }
        
    },
    actions:{
        
    },
    getters:{
        
    }

}